export default __webpack_public_path__ + "static/media/WFH-hover.9f7f22fe.svg";